import {
  Window,
  FunctionHandler,
  FunctionCallback,
  JsonData,
} from './shared/akatypes';
import {
  GenerateCourseTiles,
  GenerateFewCourseTiles,
  GenerateLecturerTile,
  GenerateLecturerCoursesTiles,
  GenerateCourseDetailTile,
  GenerateCourseInstancesTile,
  GenerateMyCourses,
  GenerateMyOrders,
  GenerateInterestDialog,
} from './akahtml';
import {
  confirmCtkButtons,
  alertCtk,
  alertCtkOKFunction,
} from './shared/utils';
import {
  ajaxUniGetAsync,
  ajaxUniPostUsingCaptcha,
  ajaxUniPut,
  ajaxUniDelete,
  ajaxLogout,
  ajaxPlatebniBranaAkaPost,
} from './shared/ajaxutils';
import { bindSaveInterestBlock } from './bracketblink';

declare const window: Window;

const jQuery = window.jQuery;

let globalTemplateId = 0;
let globalIsTemplate = false;

export function asyncsleep(milisec: number): Promise<boolean> {
  return new Promise((resolve, reject) => {
    console.log('sleeping');
    setTimeout(() => {
      resolve(true);
    }, milisec);
  });
}

export function LoadLecturersAsync(): Promise<boolean> {
  return new Promise((resolve, reject) => {
    const data = {};
    const successFunc = (result: string) => {
      console.log('load lecturers returned');
      const parsed = JSON.parse(result.trim());
      console.log(parsed);
      const json = { ...parsed };
      window.lecturers = json.lecturers;
      jQuery('#lecturersdiv').html(
        '' +
          //json.lecturers.map((it: string) => '<li>' + it + '</li>').join('\n') +
          json.lecturers
            .map((it: any) => '' + GenerateLecturerTile(it) + '')
            .join('\n') +
          '',
      );
      window.lecturers.forEach((it: any) => {
        it.courseids = [];
      });
      resolve(true);
    };
    ajaxUniGetAsync('ListLecturers', data, successFunc);
  });
}

export function LoadLecturerDetailAsync(id: number): Promise<boolean> {
  return new Promise((resolve, reject) => {
    const data = { id: id };
    const successFunc = (result: string) => {
      console.log('load lecturer detail returned');
      const parsed = JSON.parse(result.trim());
      console.log(parsed);
      const json = { ...parsed };
      jQuery('#lecturerdiv').html(
        'vysledek: <ul>' +
          json.lecturers.map((it: string) => '<li>' + it + '</li>').join('\n') +
          '</ul>',
      );
      resolve(true);
    };
    ajaxUniGetAsync('LoadlecturerDetail', data, successFunc);
    return false;
  });
}

export function LoadCoursesAsync(): Promise<boolean> {
  return new Promise((resolve, reject) => {
    const data = {};
    const successFunc = (result: string) => {
      console.log('load courses returned');
      const parsed = JSON.parse(result.trim());
      console.log(parsed);
      const json = { ...parsed };
      jQuery('#coursesdiv').html(
        '<div class="row-main"><div class="h1 u-mb-sm c-courses__title"><span class="icon-svg icon-svg--bracket u-color-lightgreen"><svg class="icon-svg__svg" xmlns:xlink="https://www.w3.org/1999/xlink"><use xlink:href="css/icon-bracket.svg#icon-bracket" x="0" y="0" width="100%" height="100%"></use></svg></span><span class="title--bracket">Nejbližší kurzy</span></div><div class="c-courses__list grid">' +
          // json.courses.map((it: string) => '<li>' + it + '</li>').join('\n') +
          // .map((it: any) => '' + GenerateCourseTile(it) + '')            .join('\n') +
          GenerateCourseTiles(json.courses) +
          '</div></div></div>',
      );
      resolve(true);
    };
    ajaxUniGetAsync('ListCourses', data, successFunc);
  });
}

export function LoadFewCoursesAsync(): Promise<boolean> {
  return new Promise((resolve, reject) => {
    const data = {};
    const successFunc = (result: string) => {
      console.log('load courses returned');
      const parsed = JSON.parse(result.trim());
      console.log(parsed);
      const json = { ...parsed };
      jQuery('#coursesdiv').html(
        '<div class="row-main"><div class="h1 u-mb-sm c-courses__title"><span class="icon-svg icon-svg--bracket u-color-lightgreen"><svg class="icon-svg__svg" xmlns:xlink="https://www.w3.org/1999/xlink"><use xlink:href="css/icon-bracket.svg#icon-bracket" x="0" y="0" width="100%" height="100%"></use></svg></span><span class="title--bracket">Nejbližší kurzy</span></div><div class="c-courses__list grid">' +
          // json.courses.map((it: string) => '<li>' + it + '</li>').join('\n') +
          // .map((it: any) => '' + GenerateCourseTile(it) + '')            .join('\n') +
          GenerateFewCourseTiles(json.courses) +
          '</div></div></div>',
      );
      resolve(true);
    };
    ajaxUniGetAsync('ListCourses', data, successFunc);
  });
}

export function LoadCourseDetailAsync(id: string): Promise<boolean> {
  return new Promise((resolve, reject) => {
    const data = { id: id };
    const successFunc = (result: string) => {
      console.log('load course detail returned');
      const parsed = JSON.parse(result.trim());
      console.log(parsed);
      const json = { ...parsed };
      if (json.course && json.course.templateid) {
        globalTemplateId = json.course.templateid;
      } else if (json.course.templatecourse === true) {
        globalTemplateId = json.course.id;
        globalIsTemplate = true;
      }
      jQuery('#coursediv').html(GenerateCourseDetailTile(json.course));
      if (json.course.templatecourse === true) {
        jQuery('#interestdiv').html(GenerateInterestDialog(json.course.id));
        bindSaveInterestBlock();
        // jQuery('#addtocart_' + id).html('Přidat do košíku neklikací');
        jQuery('#addtocart_' + id).html('');
      }
      // jQuery('#interestdiv').html(GenerateInterestDialog(id));
      resolve(true);
    };
    ajaxUniGetAsync('CourseDetail', data, successFunc);
    return false;
  });
}

export function LoadOrderDetailAsync(id: string): Promise<boolean> {
  return new Promise((resolve, reject) => {
    const data = { orderid: id };
    const successFunc = (result: string) => {
      console.log('load order detail returned');
      const parsed = JSON.parse(result.trim());
      console.log(parsed);
      const json = { ...parsed };
      /*
      if (json.course && json.course.templateid) {
        globalTemplateId = json.course.templateid;
      }
      jQuery('#coursediv').html(GenerateCourseDetailTile(json.course));
      if (json.course.templatecourse === true) {
        jQuery('#interestdiv').html(GenerateInterestDialog(json.course.id));
        jQuery('#addtocart_' + id).html('Přidat do košíku neklikací');
      }
      //jQuery('#interestdiv').html(GenerateInterestDialog(id));
      */
      resolve(true);
    };

    ajaxUniGetAsync('LoadAkaOrder', data, successFunc);
    return false;
  });
}

export function LoadCourseInstancesForLastLoadedDetailAsync(): Promise<
  boolean
> {
  return new Promise((resolve, reject) => {
    const data = { id: globalTemplateId };
    const successFunc = (result: string) => {
      console.log('load course instances returned');
      const parsed = JSON.parse(result.trim());
      console.log(parsed);
      const json = { ...parsed };
      jQuery('#instancediv').html(GenerateCourseInstancesTile(json.courses));
      if (
        globalIsTemplate === true &&
        json.courses &&
        json.courses.length > 0
      ) {
        //redirect to first instance
        window.location.assign('kurz.php?id=' + json.courses[0].id);
      }
      resolve(true);
    };
    ajaxUniGetAsync('ListCourseInstances', data, successFunc);
    return false;
  });
}
/*
export async function LoadFewCoursesAsync(): Promise<boolean> {
  return new Promise((resolve, reject) => {
    const data = {};
    const successFunc = (result: string) => {
      console.log('load few courses returned');
      const parsed = JSON.parse(result.trim());
      console.log(parsed);
      const json = { ...parsed };
      jQuery('#coursesdiv').html(
        'vysledek: <ul>' +
          json.courses.map((it: string) => '<li>' + it + '</li>').join('\n') +
          '</ul>',
      );
      resolve(true);
    };
    ajaxUniGetAsync('ListFewCourses', data, successFunc);
  });
  return false;
}
*/
export async function MarkMyCoursesAsync(): Promise<boolean> {
  return new Promise((resolve, reject) => {
    const data = {};
    const successFunc = (result: string) => {
      console.log('ListMyCourses returned');

      const parsed = JSON.parse(result.trim());
      console.log(parsed);
      const json = { ...parsed };
      json.mycourses.forEach((id: number) => {
        const j = jQuery('#occupancy_' + id);
        console.log('ListMyCourses len' + j.length);
        j.html('mám objednaný/v košíku');
        // jQuery('#addtocart_' + id).html('Přidat do košíku neklikací');
        jQuery('#addtocart_' + id).html(
          '<a href="kosik.php">Kurz již máte v košíku</a>',
        );
      });

      resolve(true);
    };
    ajaxUniGetAsync('ListMyCourses', data, successFunc);
    return false;
  });
}

export function MarkCoursesOccupancyAsync(): Promise<boolean> {
  return new Promise((resolve, reject) => {
    const data = {};
    const successFunc = (result: string) => {
      console.log('MarkCoursesOccupancyAsync returned');
      const parsed = JSON.parse(result.trim());
      console.log(parsed);
      const json = { ...parsed };
      json.coursesfree.forEach((it: any) => {
        const id = it[0];
        const templateid = it[3];
        const freeseats = it[1];
        const j1 = jQuery('#occupancy1_' + id);
        const j2 = jQuery('#occupancy2_' + id);
        console.log('MarkCoursesOccupancyAsync len' + j1.length);
        if (j1.length > 0) {
          if (freeseats === 0) {
            j1.html('Obsazeno');
            j2.html('Obsazeno');
            // jQuery('#addtocart_' + id).html('Přidat do košíku neklikací');
            jQuery('#addtocart_' + id).html('');
            jQuery('#interestdiv').html(GenerateInterestDialog(templateid));
            bindSaveInterestBlock();
          } else if (freeseats == 1) {
            j1.html('Poslední místo');
            j2.html('Poslední místo');
            //jQuery('#addtocart_' + id).html('Přidat do košíku neklikací');
            // jQuery('#addtocart_' + id).html('');
            // jQuery('#interestdiv').html(GenerateInterestDialog(templateid));
            // bindSaveInterestBlock();
            jQuery('#addtocart_' + id).removeClass('addtocarthidden');
          } else if (freeseats > 1 && freeseats <= 2) {
            j1.html('Poslední místa');
            j2.html('Poslední místa');
            jQuery('#addtocart_' + id).removeClass('addtocarthidden');
            // jQuery('#addtocart_' + id).html('Přidat do košíku neklikací');
            // jQuery('#addtocart_' + id).html('');
            // jQuery('#interestdiv').html(GenerateInterestDialog(templateid));
            // bindSaveInterestBlock();
          } else {
            jQuery('#addtocart_' + id).removeClass('addtocarthidden');
          }
        }
      });
      resolve(true);
    };
    ajaxUniGetAsync('LoadCoursesOccupancy', data, successFunc);
    return false;
  });
}

export function LoadLecturersCoursesAsync(): Promise<boolean> {
  return new Promise((resolve, reject) => {
    const data = {};
    const successFunc = (result: string) => {
      console.log('LoadLecturersCoursesAsync returned');
      const parsed = JSON.parse(result.trim());
      console.log(parsed);
      const json = { ...parsed };
      json.lecturerscourses.forEach((it: any) => {
        const lecturerid = it[0];
        const courseid = it[1];

        window.lecturers.forEach((lecturer: any) => {
          if (lecturer.id == lecturerid) {
            lecturer.courseids.push(courseid);
            console.log('pridavam ' + courseid + ' do ' + lecturerid);
          } else {
            console.log('nepridavam ' + courseid + ' do ' + lecturerid);
          }
        });
      });
      /*jQuery('#plnitjs').html(
        'vysledek: <ul>' +
          json.courses.map((it: string) => '<li>' + it + '</li>').join('\n') +
          '</ul>',
      );*/

      window.lecturers.forEach((it: any) => {
        if (it.courseids.length > 0) {
          jQuery('#lecturercourses_' + it.id).html(
            '<div class="u-font-bold">Kurzy:</div>' +
              GenerateLecturerCoursesTiles(it.courseids),
          );
        }
      });
      resolve(true);
    };
    ajaxUniGetAsync('LoadLecturersCourses', data, successFunc);
    return false;
  });
}

export function LoadCourseNamesAsync(): Promise<boolean> {
  return new Promise((resolve, reject) => {
    const data = {};
    const successFunc = (result: string) => {
      console.log('LoadLecturerCourses returned');
      const parsed = JSON.parse(result.trim());
      console.log(parsed);
      const json = { ...parsed };
      /*
      jQuery('#plnitjs').html(
        'vysledek: <ul>' +
          json.courses.map((it: string) => '<li>' + it + '</li>').join('\n') +
          '</ul>',
      );
      */
      window.courseNames = json.coursenames;
      resolve(true);
    };
    ajaxUniGetAsync('LoadCourseNames', data, successFunc);
    return false;
  });
}

export function ShowMyCartSummaryAsync(): Promise<boolean> {
  return new Promise((resolve, reject) => {
    const data = {};
    const successFunc = (result: string) => {
      console.log('LoadMyCart returned');
      const parsed = JSON.parse(result.trim());
      console.log(parsed);
      const json = { ...parsed };
      console.log('myCartSummary:', json.cartsummary);
      if (json.cartsummary !== undefined && json.cartsummary > 0) {
        jQuery('#cartspan').html(json.cartsummary);
        jQuery('#cartspan').removeClass('u-hide');
      }
      resolve(true);
    };
    ajaxUniGetAsync('LoadMyCartSummary', data, successFunc);
    return false;
  });
}

export function AddToMyCart(courseid: number, text: string): Promise<boolean> {
  return new Promise((resolve, reject) => {
    const data = { courseid: courseid };
    const successFunc = (result: string) => {
      console.log('LoadMyCart returned');
      const parsed = JSON.parse(result.trim());
      console.log(parsed);
      const okCartFunction = () => {
        window.location.assign('kosik.php');
      };
      const okStayFunction = () => {
        // window.location.reload();
        window.location.assign('kurzy.php');
      };
      const json = { ...parsed };
      if (json.status == 'alreadyincart') {
        const okCartFunction = () => {
          window.location.assign('kosik.php');
        };
        confirmCtkButtons(
          '<b>Kurz už byl v košíku.</b></br />(' +
            text +
            ')<br />Chcete přejít do košíku, nebo ještě nakupovat?',
          'Přejít do košíku',
          'Ještě nakupovat',
          okCartFunction,
          okStayFunction,
        );
      } else {
        const okCartFunction = () => {
          window.location.assign('kosik.php');
        };
        confirmCtkButtons(
          '<b>Kurz byl vložen do košíku.</b></br />(' +
            text +
            ')<br />Chcete přejít do košíku, nebo ještě nakupovat?',
          'Přejít do košíku',
          'Ještě nakupovat',
          okCartFunction,
          okStayFunction,
        );
      }
      resolve(true);
    };
    ajaxUniGetAsync('AddToMyCart', data, successFunc);
    return false;
  });
}
window.addcart = async (courseid: number, text: string) => {
  await AddToMyCart(courseid, text);
  await ShowMyCartSummaryAsync();
};

export function LoadMyCoursesAsync(): Promise<boolean> {
  return new Promise((resolve, reject) => {
    const data = {};
    const successFunc = (result: string) => {
      console.log('loadmycourses returned');
      const parsed = JSON.parse(result.trim());
      console.log(parsed);
      const json = { ...parsed };

      if (json.courses === undefined) {
        jQuery('#akamycoursesdiv').html('<p>Chyba při načítání kurzů</p>');
      } else if (json.courses.length > 0) {
        jQuery('#akamycoursesdiv').html(GenerateMyCourses(json.courses));
      } else {
        jQuery('#akamycoursesdiv').html('<p>Žádné kurzy nejsou objednané</p>');
      }
      resolve(true);
    };
    ajaxUniGetAsync('LoadMyCourses', data, successFunc);
    return false;
  });
}

function hideWholeSectionsIfNeeded() {
  if (
    window.profileactiveakademie === true &&
    window.profileactivectk24 === true
  ) {
    jQuery('#nasesluzby').hide();
    jQuery('#aktivnisluzby').show();
  }
  if (
    window.profileactiveakademie === false &&
    window.profileactivectk24 === false
  ) {
    jQuery('#nasesluzby').show();
    jQuery('#aktivnisluzby').hide();
  }
}

export function LoadMyOrdersAsync(): Promise<boolean> {
  return new Promise((resolve, reject) => {
    const data = {};
    const successFunc = (result: string) => {
      console.log('loadmyorders returned');
      const parsed = JSON.parse(result.trim());
      console.log(parsed);
      const json = { ...parsed };
      if (json.orders === undefined) {
        jQuery('#akamyordersdiv').html('<p>Chyba při načítání objednávek</p>');
      } else if (json.orders.length > 0) {
        jQuery('#akamyordersdiv').html(GenerateMyOrders(json.orders));
        window.profileactiveakademie = true;
        jQuery('#inactiveakademie').hide();
        jQuery('#activeakademie').show();
        jQuery('#aktivnisluzby').show();
        hideWholeSectionsIfNeeded();
      } else {
        jQuery('#akamyordersdiv').html('<p>Nemáte žádné objednávky</p>');
        window.profileactiveakademie = false;
        jQuery('#inactiveakademie').show();
        jQuery('#activeakademie').hide();
        jQuery('#nasesluzby').show();
        hideWholeSectionsIfNeeded();
      }
      resolve(true);
    };
    ajaxUniGetAsync('LoadMyOrders', data, successFunc);
    return false;
  });
}

function showInterestForm() {
  // alert('showinterest');
}
function hideInterestForm() {
  // alert('hideinterest');
  jQuery('#saveinterestblock').addClass('u-hide');
}

export function SaveInterest(courseid: number): Promise<boolean> {
  return new Promise((resolve, reject) => {
    const email = jQuery('#interestemailid').val();
    const data = { courseid: courseid, email: email };
    const successFunc = (result: string) => {
      console.log('SaveInterest returned');
      const parsed = JSON.parse(result.trim());
      console.log(parsed);
      const json = { ...parsed };
      if (json.status === 'ok') {
        alertCtkOKFunction(
          '<b>E-mail uložen.</b><br /><br />Až bude vypsán kurz, budeme Vás informovat.',
          hideInterestForm,
        );
      } else if (json.status === 'okfreeavailable') {
        alertCtkOKFunction(
          '<b>E-mail uložen.</b><br /><br />Až bude vypsán kurz, budeme Vás informovat.',
          hideInterestForm,
        );
      } else if (json.status === 'alreadyinterested') {
        alertCtkOKFunction(
          '<b>Váš zájem již máme zaznamenán.</b><br />Až bude vypsán kurz, budeme Vás informovat.',
          hideInterestForm,
        );
      } else if (json.status === 'bademail') {
        alertCtk('<b>Tento e-mail není platný.</b></br />');
      } else if (json.error === 'APINotOK') {
        alertCtk(
          'Stránky jsou momentálně nedostupné, zkuste provést akci později nebo nás kontaktujte na e-mailu shop@ctk.cz',
        );
      }
      resolve(true);
    };
    ajaxUniGetAsync('SaveInterest', data, successFunc);
    return false;
  });
}

window.saveinterest = async (courseid: number) => {
  await SaveInterest(courseid);
};
